module.exports = __webpack_public_path__ + "img/escudo-blanco.5d121ab6.png";